import Container from "@mui/material/Container"
import React from "react"
import {
  flexBox,
  getMediaFor,
  MEDIA_BREAKPOINT_KEYS,
  WINDOW_MEDIA_QUERIES,
} from "style/style_snippets"
import { useMediaQuery, useTheme } from "@mui/material"
import HomeParagraph from "components/HomePage/sections/HomeFirstSection/components/HomeParagraph"
import HomeQuotation from "./components/HomeQuotation"

const HomeFirstSection = () => {
  const theme = useTheme()

  const homeFirstSectionStyle = {
    container: {
      ...flexBox.row,
      justifyContent: "space-between",
      paddingTop: 42,
      paddingBottom: 55,

      [WINDOW_MEDIA_QUERIES[MEDIA_BREAKPOINT_KEYS.xs]]: {
        paddingTop: 52,
        paddingBottom: 65,
      },
      [WINDOW_MEDIA_QUERIES[MEDIA_BREAKPOINT_KEYS.sm]]: {
        paddingTop: 62,
        paddingBottom: 75,
      },
      [WINDOW_MEDIA_QUERIES[MEDIA_BREAKPOINT_KEYS.md]]: {
        paddingTop: 72,
        paddingBottom: 95,
      },
    },

    paragraphs: {
      ...getMediaFor("width", "100%", {
        [MEDIA_BREAKPOINT_KEYS.xs]: "100%",
        [MEDIA_BREAKPOINT_KEYS.sm]: "45%",
      }),
    },
  }

  const quotation = {
      title: "Our Mission",
      description: (
        <>
          Tomorrow's world of mobility is full of challenges that are best
          tackled together. We strive to spark collaboration and innovation with
          Open Source software between brilliant and passionate minds. Join the
          fun!
        </>
      ),
    },
    paragraphs = [
      {
        title: "Learn & Share",
        description: (
          <>
            With Open Source we can learn from each other and share our
            experiences and values – internally and with the external coding
            community. We support a learning culture and open communication to
            enable and encourage our employees to collaborate within the
            community. We strive to contribute to Open Source software in order
            to shape the mobility of tomorrow together.
          </>
        ),
      },
      {
        title: "Innovation & Sustainability",
        description: (
          <>
            The automotive sector continues to take steps towards emission-free
            and sustainable mobility. To achieve this, digital innovations that
            cannot be imagined without Open Source are needed. We embrace Open
            Source software to accomplish these global challenges together with
            you – the Open Source community.
          </>
        ),
      },
      {
        title: "Diversity & Respect",
        description: (
          <>
            Mercedes-Benz is a company with business relationships all over the
            world.{" "}
            <a
              href="https://group.mercedes-benz.com/sustainability/basics/employees/diversity-inclusion.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Diversity
            </a>{" "}
            and respectful behavior is an integral part of our culture. We
            commit ourselves to create a working environment characterized by
            appreciation, respect and equal opportunities for everyone. We work
            with an open mindset and act in a{" "}
            <a
              href="https://group.mercedes-benz.com/company/compliance/integrity-code.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              responsible, respectful and trustworthy manner
            </a>
            .
          </>
        ),
      },
    ]

  const mediaMatch = useMediaQuery(
    theme.breakpoints.up(MEDIA_BREAKPOINT_KEYS.sm)
  )

  const paragraphsList = paragraphs.map((h, i) => (
    <HomeParagraph key={i} {...{ ...h }} />
  ))

  if (!mediaMatch) {
    paragraphsList.push(
      <HomeParagraph
        key={"mission"}
        title={quotation.title}
        description={quotation.description}
      />
    )
  }

  return (
    <Container css={homeFirstSectionStyle.container} maxWidth={"md"}>
      <div css={homeFirstSectionStyle.paragraphs}>{paragraphsList}</div>
      {mediaMatch && <HomeQuotation {...{ quotation }} />}
    </Container>
  )
}

export default HomeFirstSection
